import * as React from "react";
import { SingleNavMenuLink } from "../../../pages/identity/useNavMenu";
import { useLocation } from "react-router-dom";
import { useSingleNavMenuContext } from "./useSingleNavMenuContext";
import { BasePathContext } from "../../../reactContexts/basePathContext";

export function useSingleNavMenuActiveLink(_links: SingleNavMenuLink[]) {
  const componentName = `"useSingleNavMenuActiveLink"`;

  const { pathname } = useLocation();
  const basePath = React.useContext(BasePathContext);
  const { setActiveLinkId } = useSingleNavMenuContext();

  const links = React.useMemo(() => {
    return _links.filter((l) => (l as any).isPage || (l as any).isSection);
  }, [JSON.stringify(_links)]);

  const [foundElements, setFoundElements] = React.useState(false);
  const [queryCount, setQueryCount] = React.useState(0);
  const QUERY_COUNT_LIMIT = 5;

  React.useEffect(() => {
    if (queryCount >= QUERY_COUNT_LIMIT) {
      console.error(`Cannot process ${componentName}, query count is depleted without finding elements`);
      return;
    }

    const pageMain = document.querySelector(`#page main`) as HTMLElement;
    if (!pageMain) {
      setQueryCount((x) => x + 1);
      return;
    }

    const nav = document.querySelector(`.singlenav-backdrop nav`) as HTMLElement;
    if (!nav) {
      setQueryCount((x) => x + 1);
      return;
    }

    setFoundElements(true);
  }, [foundElements, queryCount]);

  const updateActiveLink = React.useCallback(() => {
    if (!links || links.length < 1) {
      return;
    }

    const relativePath = pathname.slice(basePath.length);

    let activeLinkId = "";
    let activeLinkLabel = "";
    for (const link of links) {
      const linkPath = `${(link as any).page}${(link as any).section ? `/${(link as any).section}` : ""}`;
      if (relativePath === linkPath || relativePath.startsWith(linkPath + "/")) {
        activeLinkId = link.id;
        activeLinkLabel = (link as any).label;
      }
    }
    if (!activeLinkId) {
      activeLinkId = links[0].id;
      activeLinkLabel = (links[0] as any).label;
    }

    setActiveLinkId(activeLinkId);
  }, [pathname, basePath, JSON.stringify(links)]);

  React.useEffect(() => {
    if (!foundElements) {
      return;
    }

    const pageMain = document.querySelector(`#page main`) as HTMLElement;
    if (!pageMain) {
      console.error(`Cannot process ${componentName} without being able to access element "#page main"`);
      return;
    }

    const el = document.querySelector(`.singlenav-backdrop nav`) as HTMLElement;
    if (!el) {
      console.error(`Cannot process ${componentName} without being able to access element ".singlenav-backdrop nav"`);
      return;
    }

    updateActiveLink();
    window.addEventListener("resize", updateActiveLink);

    return () => {
      window.removeEventListener("resize", updateActiveLink);
    };
  }, [foundElements, queryCount, , pathname, JSON.stringify(links)]);
}
